import "./styles.scss";

import { useTranslation } from "react-i18next";
import moment from "moment";
import classnames from "classnames";

import PlaceholderAvatarImage from "assets/images/avatar-placeholder.png";

const mainClass = "task-view-status";

const StatusMessage = ({
  template,
  date,
  user,
  isHighlighted,
  isInViewport,
}) => {
  const { t } = useTranslation();

  const renderText = (template) => {
    switch (template) {
      case 0:
        return `${t("Task has been created")}`;
      case 1:
        return `${t("Task status changed to")} "${t("Open")}"`;
      case 2:
        return `${t("Task status changed to")} "${t("To do")}"`;
      case 3:
        return `${t("Task status changed to")} "${t("In progress")}"`;
      case 4:
        return `${t("Task status changed to")} "${t("Client verification")}"`;
      case 5:
        return `${t("Task status changed to")} "${t("On hold")}"`;
      case 6:
        return `${t("Task status changed to")} "${t("Closed")}"`;
      case 7:
        return `${t("Task priority changed to")} "${t("Low")}"`;
      case 8:
        return `${t("Task priority changed to")} "${t("Normal")}"`;
      case 9:
        return `${t("Task priority changed to")} "${t("High")}"`;
      case 10:
        return `${t("Task priority changed to")} "${t("Urgent")}"`;
      default:
        return "";
    }
  };

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--highlighted`]: isHighlighted,
        [`${mainClass}--in-viewport`]: isInViewport,
      })}
    >
      <div className={`${mainClass}__avatar`}>
        <img src={user?.avatar || PlaceholderAvatarImage} alt="" />
      </div>
      <p>
        {moment(date)?.format("lll")} - {renderText(template)} {t("by")}{" "}
        {user?.name ?? t("Unknown")}.
      </p>
    </div>
  );
};

export default StatusMessage;
